






































import { computed, defineComponent, ref } from "@vue/composition-api";
import { checkAuthorities } from "@scrile/tools/dist/lib/SecurityHelpers";
import useAuthUser from "@/hooks/useAuthUser";
import { useGroups } from "@/hooks/useGroups";
import usePager from "@/hooks/usePager";
import providers from "@/lib/api";
import { $t } from "@/lib/i18nHelpers";
import config from "@/config";
import { BaseMenuItem } from "@/types";
import BaseIconButton from "@/components/BaseIconButton";
import BaseMenu from "@/components/BaseMenu";
import BasePage from "@/components/BasePage";
import EmptyContent from "@/components/EmptyContent";
import InfiniteScroll from "@/components/InfiniteScroll";
import PageTitle from "@/components/PageTitle";
import MassMessageStatView from "./components/MassMessageStatView";
import UnsendConfirm from "./components/UnsendConfirm";

export default defineComponent({
  name: "PageMassMessageStat",
  components: {
    BaseIconButton,
    BaseMenu,
    UnsendConfirm,
    InfiniteScroll,
    BasePage,
    PageTitle,
    EmptyContent,
    MassMessageStatView,
  },
  setup() {
    const { authUserStrict: user, authorities } = useAuthUser();
    const { hasGroupWithMoreThanOneMember: allowMassMessage, getMyGroups } = useGroups();
    const loading = ref(false);
    const unsendId = ref<string | null>(null);
    const unsendPaid = ref<boolean>(false);
    const unsendMessageConfirm = ref(false);

    const allowScheduledMassMessage = computed(() => config.featureScheduledMassMessage && allowMassMessage.value);

    const menuItems = computed<BaseMenuItem[]>(() => {
      const items = [];
      if (allowMassMessage.value) {
        items.push({
          name: "sendMassMessage",
          text: $t("Send Mass message"),
          prependIcon: "msr-send",
        });
      }
      if (allowScheduledMassMessage.value) {
        items.push({
          name: "scheduledMassMessage",
          text: $t("Scheduled mass messages"),
          prependIcon: "msr-calendar_today",
        });
      }
      return items;
    });

    const { enableScroll, items, getNextPage, getFirstPage } = usePager(page =>
      providers.MassMessageStatProvider.search({
        data: {
          senderId: user.value.id,
          page,
          size: 5,
          sort: "TIME,DESC",
        },
      })
    );

    const getGroups = () => {
      if (checkAuthorities(authorities.value, ["updateMyContentPrice"])) return getMyGroups();
    };

    const getData = async () => {
      try {
        loading.value = true;
        await Promise.all([getFirstPage(), getGroups()]);
      } finally {
        loading.value = false;
      }
    };

    const unsendMessage = async () => {
      if (!unsendId.value) return;
      loading.value = true;
      try {
        const status = await providers.MassMessageStatProvider.unsend({ id: unsendId.value });
        if (status) {
          const item = items.value.find(item => item.id === unsendId.value);
          if (item) item.unsended = true;
        }
      } finally {
        loading.value = false;
        unsendMessageConfirm.value = false;
      }
    };

    const unsendMessageShow = (data: { id: string; paid: boolean }) => {
      unsendMessageConfirm.value = true;
      unsendId.value = data.id;
      unsendPaid.value = data.paid;
    };

    getData();

    return {
      loading,
      menuItems,
      items,
      enableScroll,
      getNextPage,
      unsendMessage,
      unsendId,
      unsendPaid,
      unsendMessageConfirm,
      unsendMessageShow,
    };
  },
});
